// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 도움말 컨테이너 */
.help-tip-container {
  display: inline-block;
  position: relative;
}

/* 도움말 아이콘 */
.help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ddd;
  color: #666;
  font-size: 14px;
  margin-left: 8px;
  cursor: pointer;
}

/* 도움말 박스 */
.help-tip-box {
  position: absolute;
  bottom: 30px;
  left: 210%;
  transform: translateX(-50%);
  width: 320px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  padding: 15px;
  z-index: 100;
}

/* 도움말 박스 제목 */
.help-tip-box h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: bold;
}

/* 도움말 박스 내용 */
.help-tip-box p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

/* 도움말 박스 화살표 */
.help-tip-arrow {
  position: absolute;
  width: 15px;
  height: 15px;
  background: white;
  transform: rotate(45deg);
  bottom: -8px;
  left: 37%;
  margin-left: -7px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
} `, "",{"version":3,"sources":["webpack://./src/styles/HelpTip.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,YAAY;AACd;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;AAC/B","sourcesContent":["/* 도움말 컨테이너 */\n.help-tip-container {\n  display: inline-block;\n  position: relative;\n}\n\n/* 도움말 아이콘 */\n.help-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #ddd;\n  color: #666;\n  font-size: 14px;\n  margin-left: 8px;\n  cursor: pointer;\n}\n\n/* 도움말 박스 */\n.help-tip-box {\n  position: absolute;\n  bottom: 30px;\n  left: 210%;\n  transform: translateX(-50%);\n  width: 320px;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.2);\n  padding: 15px;\n  z-index: 100;\n}\n\n/* 도움말 박스 제목 */\n.help-tip-box h3 {\n  margin: 0 0 10px 0;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n/* 도움말 박스 내용 */\n.help-tip-box p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* 도움말 박스 화살표 */\n.help-tip-arrow {\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  background: white;\n  transform: rotate(45deg);\n  bottom: -8px;\n  left: 37%;\n  margin-left: -7px;\n  border-right: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
